import React, { memo, useEffect } from "react";
import { useFormik } from "formik";
import {
  Stack,
  Button,
  Icon,
  LoadingButton,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "investira.react.components";
import { useCarteirasContext } from "../../contexts/CarteirasContext";
import { CARTEIRA_TIPO } from "../../enums";

const CarteiraEditForm = memo((props) => {
  const { state, actions } = useCarteirasContext();

  const formik = useFormik({
    initialValues: { carteira_tipo_id: "T" },
    validateOnMount: false,
    onSubmit: (pValues, pActions) => {
      pActions.setSubmitting(true);

      actions.modifyCarteira(
        { carteira_id: state.carteira_id, ...pValues },
        () => {
          actions.handleModifyCarteiraCancel();
        },
        null,
        () => {
          pActions.setSubmitting(false);
        }
      );
    },
  });

  useEffect(() => {
    props.id && actions.readCarteira(props.id);
  }, [props.id]);

  useEffect(() => {
    formik.setValues({
      carteira_tipo_id: state.carteira_tipo_id,
    });
  }, [
    state.carteira,
    state.carteira_seuid,
    state.carteira_tipo_id,
    props.mode,
  ]);

  return (
    <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <FormControl>
            <FormLabel id="carteira_tipo_id-label">Tipo:</FormLabel>
            <RadioGroup
              name="carteira_tipo_id"
              value={formik.values.carteira_tipo_id}
              onChange={formik.handleChange}
            >
              {Object.values(CARTEIRA_TIPO)
                .filter((xTipo) => xTipo.id !== "C")
                .map((xTipo) => {
                  return (
                    <FormControlLabel
                      key={xTipo.label}
                      value={xTipo.id}
                      control={<Radio />}
                      label={xTipo.label}
                    />
                  );
                })}
            </RadioGroup>
          </FormControl>
        </Stack>
        <Stack
          flex={1}
          direction="row"
          justifyContent="flex-end"
          sx={{ py: 2 }}
          spacing={2}
        >
          <Button
            variant="outlined"
            type="button"
            color="primary"
            onClick={actions.handleModifyCarteiraCancel}
          >
            Cancelar
          </Button>
          <LoadingButton
            startIcon={<Icon iconName="save" size={16} />}
            variant="contained"
            type="submit"
            loading={formik.isSubmitting}
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Salvar
          </LoadingButton>
        </Stack>
      </Stack>
    </form>
  );
});

CarteiraEditForm.displayName = "CarteiraEditForm";

export default CarteiraEditForm;
